import * as React from "react";

function TroubleshootIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} {...props} viewBox="0 0 24 24"><path fill="#039be5" d="m20.6 21l-4.7-4.7q-1.025.8-2.262 1.25T11 18q-2.25 0-4.062-1.1T4.075 14h2.45q.85.925 1.988 1.463T11 16q2.5 0 4.25-1.75T17 10t-1.75-4.25T11 4Q8.65 4 6.938 5.588T5.025 9.5h-2q.2-3.175 2.488-5.337T11 2q3.35 0 5.675 2.325T19 10q0 1.4-.45 2.638T17.3 14.9l4.7 4.7zM9.925 14L8.35 8.8l-1.3 3.7H2V11h4l1.65-4.75h1.5l1.525 5.1L11.75 8h1.5l1.5 3h.75v1.5h-1.675l-1.175-2.35L11.4 14z" /></svg>
    );
}

export default TroubleshootIcon;
